export type RoastersEmptyMode = 'search' | 'needs' | 'complete' | 'all';

const COPY: Record<RoastersEmptyMode, { title: string; subtitle: string }> = {
  search: { title: 'No roasters found', subtitle: 'Try a different search term.' },
  needs: { title: 'All caught up', subtitle: 'Every roaster has a shop URL and platform.' },
  complete: {
    title: 'Nothing indexed yet',
    subtitle: 'Add shop details, or mark roasters that sell nothing online.',
  },
  all: { title: 'No roasters yet', subtitle: 'Roasters added to Wolisho will appear here.' },
};

export function RoastersEmptyState({ mode }: { mode: RoastersEmptyMode }) {
  const { title, subtitle } = COPY[mode];
  const caughtUp = mode === 'needs';

  return (
    <div className="px-4 py-11 text-center" data-testid="roasters-empty">
      <div className="mx-auto mb-3.5 flex h-12 w-12 items-center justify-center rounded-xl bg-wolisho-brown/[0.06] text-wolisho-brown/30">
        {caughtUp ? (
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        ) : (
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M3 9l1.5-5h15L21 9" />
            <path d="M4 9v10a1 1 0 001 1h14a1 1 0 001-1V9" />
            <path d="M3 9h18" />
          </svg>
        )}
      </div>
      <p className="text-sm font-bold text-black/50">{title}</p>
      <p className="text-[13px] text-black/35">{subtitle}</p>
    </div>
  );
}
